import React from 'react';
import { useTheme } from 'styled-components';
import { IconInfoFilled } from '../../icons/info-filled';

type OnboardingTipType = {
    content: React.ReactNode;
};

export const OnboardingTip: React.FC<OnboardingTipType> = ({ content }) => {
    const theme = useTheme();

    if (!content || typeof content !== 'string') return null;

    return (
        <div
            className="flex items-start gap-xsmall rounded-large border p-vsmall text-medium leading-medium text-[var(--onboarding-tip-color)] [&_a]:text-inherit [&_a]:underline [&_i]:relative [&_i]:top-[0.1rem] [&_i]:h-[2rem] [&_i]:w-[2rem] [&_i]:text-[var(--onboarding-tip-icon-color)]"
            style={
                {
                    '--onboarding-tip-color': theme.palette.color.purple.main,
                    '--onboarding-tip-icon-color': theme.palette.color.purple.lighten,
                    borderColor: theme.palette.color.purple.opacity.medium,
                } as React.CSSProperties
            }
        >
            <IconInfoFilled /> <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );
};
